<template>
  <div>
    <MainBestSellingAndLessSoldProductReport />
  </div>
</template>

<script>
import MainBestSellingAndLessSoldProductReport from "@/components/Reports/Products/BestSellingAndLessSoldProductReport/MainBestSellingAndLessSoldProductReport.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "BestSellingAndLessSold",
  components: {
    MainBestSellingAndLessSoldProductReport,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
